import { render, staticRenderFns } from "./sklib-footer.vue?vue&type=template&id=72f65da9&scoped=true&"
import script from "./sklib-footer.vue?vue&type=script&lang=js&"
export * from "./sklib-footer.vue?vue&type=script&lang=js&"
import style0 from "./sklib-footer.vue?vue&type=style&index=0&id=72f65da9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f65da9",
  null
  
)

export default component.exports